export default __webpack_public_path__ + "static/media/cataracts1.6a46291a.jpg";